export default {
  hasLabel: {
    position: 'relative',
    top: -3,
    'margin-right': 10,
  },
};
